module.exports = __webpack_public_path__ + "img/1b6450a.jpeg";